module.exports = __webpack_public_path__ + "img/bandeau-JPO-2.0d726ac.png";